import React from "react";
import { useRouter } from "next/router";
export function saveParamsToStorage(paramsToPersist: string[], storageKey: string, params: URLSearchParams) {
  const storedParams: Record<string, string> = {};
  for (const [key, value] of params.entries()) {
    if (paramsToPersist.includes(key)) {
      storedParams[key] = value;
    }
  }
  if (Object.keys(storedParams).length > 0) {
    localStorage.setItem(storageKey, JSON.stringify(storedParams));
  }
}

/*
 * Persists url parameters to local storage based on `paramsToPersist`
 */
export function useParamsPersistor(paramsToPersist: string[], storageKey: string) {
  const router = useRouter();
  const urlParams = React.useMemo(() => new URLSearchParams(router.asPath.split("?")[1] || ""), [router.asPath]);
  React.useEffect(() => {
    saveParamsToStorage(paramsToPersist, storageKey, urlParams);
  }, [paramsToPersist, storageKey, urlParams]);
}